/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `meters` - meters
 * @export
 */
export const UnitEnum = {
  METERS: "meters",
} as const;
export type UnitEnum = (typeof UnitEnum)[keyof typeof UnitEnum];

export function instanceOfUnitEnum(value: any): boolean {
  for (const key in UnitEnum) {
    if (Object.prototype.hasOwnProperty.call(UnitEnum, key)) {
      if (UnitEnum[key as keyof typeof UnitEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function UnitEnumFromJSON(json: any): UnitEnum {
  return UnitEnumFromJSONTyped(json, false);
}

export function UnitEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitEnum {
  return json as UnitEnum;
}

export function UnitEnumToJSON(value?: UnitEnum | null): any {
  return value as any;
}

export function UnitEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): UnitEnum {
  return value as UnitEnum;
}
